import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  iconWrap: FelaCSS;
  contentWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    maxWidthTabletSm: {
      paddingLeft: spacing[4],
      paddingRight: spacing[4],
      paddingTop: spacing[4],
      paddingBottom: spacing[6],
      backgroundColor: colors.space04,
      marginBottom: spacing[4],
    },
  },

  iconWrap: {
    marginRight: '8px',
  },

  contentWrap: {
    width: '380px',

    maxWidthTabletSm: {
      width: '100%',
    },
  },
});

export default styles;
